import React from "react";

import { isLogItemWithPath, LogItem } from "lib/build/schema";

import { LogMap } from "src/features/forms/types";

export function useLogMap(items: LogItem[]): LogMap {
	return React.useMemo(() => {
		const map: LogMap = {};
		for (const item of items) {
			if (isLogItemWithPath(item)) {
				const key = item.path.join("/");
				if (!(key in map)) {
					map[key] = {};
				}
				map[key] = { ...map[key], ...item.details };
			}
		}
		return map;
	}, [items]);
}
